import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useMemo, useState } from 'react';
import Moment from 'moment';
import DateTime from '_class/DateTime';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'lib/translate';
import { useHistory, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { setPageTitle } from 'actions/header';
import { getCourse, setActiveCourse } from 'actions/courses';
import { getSection, setActiveSection } from 'actions/sections';
import { getUserInfo } from 'actions/user';
import { getStudentAdjustmentsBySubject } from 'actions/additional_adjustments';
import { updateVerdict, createVerdict, deleteVerdict, getVerdictsForUser, getSectionVerdicts } from 'actions/verdicts';
import { getUserAssessmentDates } from 'helpers/user';
import InputVerdictForm from 'containers/Verdict/Form/VerdictForm';
import TeacherAdjustments from 'containers/AdditionalAdjustments/Display/TeacherAdjustments';
import VerdictWidget from 'containers/Verdict/Display/VerdictWidget';
import VerdictDisplay from 'containers/Verdict/Display/VerdictDisplay';
import DatePickers from "containers/Progress/Partials/DatePickers";
import UserAssessments from 'containers/Progress/Partials/UserAssessments';
import StudentAdjustmentForm from 'containers/AdditionalAdjustments/Form/StudentAdjustmentForm';
import Modal from 'containers/Modals/Modal';
import { Collapsible, Spinner } from 'UI';
import { Button, Checkbox, Expandable, Icon } from '@haldor/ui';

var fixLocalHistory = function fixLocalHistory() {
  if (localStorage.getItem('history') != null) {
    var history = JSON.parse(localStorage.getItem('history'));
    history.shift();
    localStorage.setItem('history', JSON.stringify(history));
  }
};

var NewVerdictPage = function NewVerdictPage(props) {
  var dispatch = useDispatch();
  var translate = useTranslate();
  var params = useParams();
  var history = useHistory();
  var tenant = useSelector(function (state) {
    return state.user.tenant;
  });
  var userVerdicts = useSelector(function (state) {
    return state.Verdicts.user;
  });
  var course = useSelector(function (state) {
    return state.Courses.course;
  });
  var adjustments = useSelector(function (state) {
    return state.AdditionalAdjustments.studentAdjustmentsBySubject;
  });
  var section = useSelector(function (state) {
    return state.sections.activeSection;
  });
  var activeStudent = useSelector(function (state) {
    var _state$user$info;

    return (_state$user$info = state.user.info) === null || _state$user$info === void 0 ? void 0 : _state$user$info.find(function (user) {
      return user.userId == params.userId;
    });
  });

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      showLearningGoals = _useState2[0],
      setLearningGoals = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showKnowledgeRequirements = _useState4[0],
      setKnowledgeRequirements = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showOnlyMyAssessments = _useState6[0],
      setShowOnlyMyAssessments = _useState6[1];

  var _useState7 = useState(getUserAssessmentDates()),
      _useState8 = _slicedToArray(_useState7, 2),
      dates = _useState8[0],
      setDates = _useState8[1];

  var _useState9 = useState(getUserAssessmentDates()),
      _useState10 = _slicedToArray(_useState9, 2),
      currentDates = _useState10[0],
      setCurrentDates = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 2),
      sidebar = _useState12[0],
      setSidebar = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      verdictsLoading = _useState14[0],
      setVerdictsLoading = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      adjustmentModal = _useState16[0],
      setAdjustmentModal = _useState16[1];

  var services = useSelector(function (state) {
    return state.Services.availableServices;
  });
  useEffect(function () {
    return function () {
      dispatch(setActiveCourse());
      dispatch(setActiveSection());
    };
  }, []);
  useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch(setPageTitle(translate('New evaluation')));
            setVerdictsLoading(true);
            _context.next = 4;
            return Promise.all([dispatch(getCourse(params.courseId)), dispatch(getSectionVerdicts(params.groupId, params.courseId)), dispatch(getUserInfo(params.userId, 'extended')), dispatch(getSection(params.groupId)), dispatch(getVerdictsForUser(params.userId, params.courseId))]);

          case 4:
            setVerdictsLoading(false);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [params.groupId, params.userId, params.courseId]);
  useEffect(function () {
    if (course != null) {
      dispatch(getStudentAdjustmentsBySubject(params.groupId, course.subjectId, params.userId));
    }
  }, [course]);
  useEffect(function () {
    if (activeStudent != null) {
      dispatch(setPageTitle(translate('New evaluation') + ' ' + activeStudent.firstName + ' ' + activeStudent.lastName));
    }
  }, [activeStudent]);

  var getStudents = function getStudents() {
    var _section$students;

    return (_section$students = section.students) === null || _section$students === void 0 ? void 0 : _section$students.sort(function (a, b) {
      return a.lastName.localeCompare(b.lastName);
    });
  };

  var studentIndex = useMemo(function () {
    if (section == null) {
      return null;
    }

    return getStudents().findIndex(function (student) {
      return student.userId == params.userId;
    });
  }, [section]);

  var onDateChange = function onDateChange(_ref2) {
    var start = _ref2.start,
        end = _ref2.end;

    if (start == "Invalid date") {
      start = Moment().subtract(1, "years");
    }

    if (end == "Invalid date") {
      end = Moment().add(1, "years");
    }

    setDates({
      start: new DateTime(start).getDateStamp(),
      end: new DateTime(end).getDateStamp()
    });
  };

  var reload = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setVerdictsLoading(true);
              _context2.next = 3;
              return dispatch(getVerdictsForUser(params.userId, params.courseId));

            case 3:
              setVerdictsLoading(false);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function reload() {
      return _ref3.apply(this, arguments);
    };
  }();

  var onSubmitDates = function onSubmitDates(event) {
    event.preventDefault();
    setCurrentDates(dates);
  };

  var onVerdictSubmit = function onVerdictSubmit(values) {
    return new Promise( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                values.userId = params.userId;
                values.courses = [{
                  "courseCode": course.courseCode,
                  "subjectCode": course.subjectCode,
                  "courseID": course.id
                }];

                if (!(values.id != null)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 5;
                return dispatch(updateVerdict(values));

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.next = 9;
                return dispatch(createVerdict(values));

              case 9:
                _context3.next = 11;
                return dispatch(getVerdictsForUser(params.userId, params.courseId));

              case 11:
                _context3.next = 13;
                return dispatch(getSectionVerdicts(params.groupId, params.courseId));

              case 13:
                resolve(1);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
  };

  var onDeleteVerdict = function onDeleteVerdict(id) {
    var userId = null;

    if (userVerdicts != null && userVerdicts.length > 0) {
      userId = userVerdicts[0].userId;
    }

    setVerdictsLoading(true);
    return new Promise(function (resolve) {
      dispatch(deleteVerdict(id)).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(userId != null)) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return dispatch(getVerdictsForUser(userId, params.courseId));

              case 3:
                setVerdictsLoading(false);

              case 4:
                resolve(1);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    });
  };

  var renderVerdict = function renderVerdict(verdict, index) {
    if (verdict == null || verdict.status == 'VERDICT_DRAFT') {
      return null;
    }

    var date = tenant.currentSchoolYear != null ? tenant.currentSchoolYear : '2017-01-01';
    var start = new DateTime(date).getDateStamp();
    var end = new DateTime(verdict.published).getDateStamp();
    var verdictBefore = userVerdicts[index + 1];

    if (verdictBefore != null) {
      start = new DateTime(verdictBefore.published).getDateStamp();
    }

    var trigger = /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flexGrow: 1
      }
    }, new DateTime(verdict.published).getLongDateWithTime()), /*#__PURE__*/React.createElement("div", {
      style: {
        flexGrow: 0
      }
    }, /*#__PURE__*/React.createElement(VerdictWidget, {
      verdict: verdict
    })));
    return /*#__PURE__*/React.createElement("div", {
      className: "verdict verdict-entry",
      key: verdict.id
    }, /*#__PURE__*/React.createElement(Collapsible, {
      trigger: trigger
    }, /*#__PURE__*/React.createElement(VerdictDisplay, {
      verdict: verdict,
      reload: reload,
      setLoading: function setLoading(loading) {
        return console.log('set loading', loading);
      },
      course: course
    })));
  };

  var toggleIcon = function toggleIcon(flip) {
    return /*#__PURE__*/React.createElement("i", {
      className: "cl-container",
      style: {
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlSpace: "preserve",
      className: flip ? 'i-90' : 'a-90',
      style: {
        height: '7px',
        width: '15px'
      }
    }, /*#__PURE__*/React.createElement("path", {
      className: "cls-1",
      d: "M11.361,1.4,6.38,5.9,1.4,1.4"
    })));
  };

  var renderStatus = function renderStatus() {
    if (userVerdicts != null && userVerdicts.length > 0 && userVerdicts[0].status == 'VERDICT_DRAFT') {
      return /*#__PURE__*/React.createElement("div", {
        className: "info-draft"
      }, translate('Status'), ":", /*#__PURE__*/React.createElement("span", {
        className: "draft-badge"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dot",
        style: {
          backgroundColor: '#eec157'
        }
      }), translate('Draft')));
    } else {
      return null;
    }
  };

  var goBack = function goBack(event) {
    event.preventDefault();

    if (studentIndex < 1) {
      return '#';
    }

    fixLocalHistory();
    var newStudent = getStudents()[studentIndex - 1].userId;
    history.replace("/groups/".concat(params.groupId, "/course/").concat(params.courseId, "/student/").concat(newStudent));
  };

  var goNext = function goNext(event) {
    event.preventDefault();

    if (studentIndex + 1 == (section === null || section === void 0 ? void 0 : section.students.length)) {
      return '#';
    }

    fixLocalHistory();
    var newStudent = getStudents()[studentIndex + 1].userId;
    history.replace("/groups/".concat(params.groupId, "/course/").concat(params.courseId, "/student/").concat(newStudent));
  };

  if (course == null || activeStudent == null) {
    return /*#__PURE__*/React.createElement("div", {
      className: "attached-user-documents"
    }, /*#__PURE__*/React.createElement("div", {
      className: "iframe-section left-side",
      style: {
        backgroundColor: 'transparent'
      }
    }, /*#__PURE__*/React.createElement(Spinner, {
      center: true
    })));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "attached-user-documents form form-component verdict"
  }, /*#__PURE__*/React.createElement(Modal, {
    isOpen: adjustmentModal,
    onClose: function onClose() {
      return setAdjustmentModal(false);
    },
    title: translate('assign-adjustment')
  }, /*#__PURE__*/React.createElement(StudentAdjustmentForm, {
    onClose: function onClose() {
      return setAdjustmentModal(false);
    },
    course: course,
    userId: params.userId
  })), /*#__PURE__*/React.createElement("div", {
    className: "iframe-section left-side",
    style: {
      backgroundColor: 'transparent'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "verdict-assessments-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inputs-container",
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(DatePickers, {
    startDate: dates.start,
    endDate: dates.end,
    onChange: onDateChange
  }), /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    onClick: onSubmitDates
  }, translate('Update')), /*#__PURE__*/React.createElement("div", {
    className: "row align-items-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox mr-3"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: translate('Show only my assessments'),
    value: showOnlyMyAssessments,
    onChange: setShowOnlyMyAssessments
  })), /*#__PURE__*/React.createElement("div", {
    className: "checkbox mr-3"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: translate('Learning goals'),
    value: showLearningGoals,
    onChange: setLearningGoals
  })), /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: translate('Knowledge requirements'),
    value: showKnowledgeRequirements,
    onChange: setKnowledgeRequirements
  })))), /*#__PURE__*/React.createElement("div", {
    className: "form-row",
    style: {
      marginTop: '1rem'
    }
  }, /*#__PURE__*/React.createElement(UserAssessments, {
    studentId: params.userId,
    courseId: params.courseId,
    sectionId: params.groupId,
    start: currentDates.start,
    end: currentDates.end,
    showGoals: showLearningGoals,
    showMatrices: showKnowledgeRequirements,
    showOnlyMyAssessments: showOnlyMyAssessments
  })))), sidebar ? /*#__PURE__*/React.createElement("div", {
    className: "sidebar"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '1.55rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "collapse color--meta",
    onClick: function onClick() {
      return setSidebar(false);
    }
  }, translate('fold-up'), " ", /*#__PURE__*/React.createElement(Icon, {
    name: "ArrowRight"
  })), /*#__PURE__*/React.createElement("div", {
    className: "df aic jcb",
    style: {
      marginBottom: '1.55rem'
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: "#",
    onClick: goBack
  }, studentIndex > 0 ? toggleIcon(false) : null), /*#__PURE__*/React.createElement("strong", null, translate('new-verdict') + " " + activeStudent.firstName + " " + activeStudent.lastName), /*#__PURE__*/React.createElement(Link, {
    to: "#",
    onClick: goNext
  }, studentIndex < (section === null || section === void 0 ? void 0 : section.students.length) - 1 ? toggleIcon(true) : null)), /*#__PURE__*/React.createElement("div", {
    className: "place-verdict-container"
  }, !verdictsLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, renderStatus(), /*#__PURE__*/React.createElement(InputVerdictForm, {
    onSubmit: onVerdictSubmit,
    duplicate: false,
    edit: false,
    activeStudent: params.userId,
    deleteVerdict: onDeleteVerdict,
    userVerdicts: userVerdicts
  })) : /*#__PURE__*/React.createElement(Spinner, {
    center: true
  }))), services.additionalAdjustments ? /*#__PURE__*/React.createElement(Expandable, {
    title: translate('additional-adjustments')
  }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
    adjustments: adjustments
  }), /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    onClick: function onClick() {
      setAdjustmentModal(true);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Plus"
  }), " ", translate('assign-adjustment'))) : /*#__PURE__*/React.createElement("div", {
    className: "form form-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-divider",
    style: {
      marginBottom: 40,
      marginTop: 15
    }
  })), userVerdicts != null && (userVerdicts.length > 1 || userVerdicts.length == 1 && userVerdicts[0].status != 'VERDICT_DRAFT') ? /*#__PURE__*/React.createElement(Expandable, {
    title: translate('past-verdicts')
  }, /*#__PURE__*/React.createElement("div", {
    className: "past-verdicts"
  }, userVerdicts.map(renderVerdict))) : null) : /*#__PURE__*/React.createElement("div", {
    className: "expand color--meta",
    onClick: function onClick() {
      return setSidebar(true);
    }
  }, translate('fold-out'), " ", /*#__PURE__*/React.createElement(Icon, {
    name: "ArrowLeft"
  })));
};

export default NewVerdictPage;